import React from 'react';
import { Button, EButtonType, EInputType, Input } from '@repo/apg-ui';
import 'react-date-range/dist/theme/default.css';
import 'react-date-range/dist/styles.css';
import { Modal } from 'react-bootstrap';
import './OrderQuoteModal.scss';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  show: boolean;
  setHide: any;
}

const OrderQuoteModal = ({ show, setHide }: Props) => {
  const intl = useIntl();

  const stopClickPropagation = (event) => {
    event.stopPropagation();
  };
  return (
    <Modal
      show={show}
      onHide={() => setHide()}
      onClick={stopClickPropagation}
      backdrop='static'
      size='lg'
      keyboard={false}
      className='order-quote-modal'
      centered
      backdropClassName='order-quote-backdrop'
    >
      <Modal.Header closeButton className='border-bottom'>
        <Modal.Title>
          <h2>
            <FormattedMessage id='ec.general.checkWithApg' defaultMessage='An APG|SGA senden' />
          </h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <Input
            name='message'
            inputType={EInputType.Textarea}
            label={<FormattedMessage id='input.label.yourMessage' defaultMessage='Ihre Nachricht' />}
            type='textarea'
            rows={7}
            placeholder={intl.formatMessage({
              id: 'input.placeholder.yourMessage',
              defaultMessage: `Guten Tag, ich würde gerne meine Berechnung von Ihnen überprüfen lassen.`,
            })}
          ></Input>
        </div>
      </Modal.Body>
      <Modal.Footer className='top-border'>
        <div className='d-flex flex-row gap-2'>
          <Button
            buttonType={EButtonType.InvertedPillLarge}
            onClick={(event) => {
              event.stopPropagation();
              setHide();
            }}
          >
            <FormattedMessage id='ec.general.close' defaultMessage='Schliessen' />
          </Button>
          <Button
            buttonType={EButtonType.PillLarge}
            onClick={(event) => {
              event.stopPropagation();
              setHide();
            }}
          >
            <FormattedMessage id='ec.general.sendToApgEmployee' defaultMessage='An APG|SGA senden' />
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default OrderQuoteModal;
